import { defineMessages } from 'react-intl';

export const dentalPhotoToolbarMessages = defineMessages({
  crop: {
    id: 'dentalPhotoToolbar.crop',
    defaultMessage: 'Crop',
  },
  rotate: {
    id: 'dentalPhotoToolbar.rotate',
    defaultMessage: 'Rotate',
  },
  zoom: {
    id: 'dentalPhotoToolbar.zoom',
    defaultMessage: 'Zoom',
  },
  mirror: {
    id: 'dentalPhotoToolbar.mirror',
    defaultMessage: 'Mirror',
  },
  straighten: {
    id: 'dentalPhotoToolbar.straighten',
    defaultMessage: 'Straighten',
  },
  done: {
    id: 'dentalPhotoToolbar.done',
    defaultMessage: 'Done',
  },
  cancel: {
    id: 'global.cancel',
    defaultMessage: 'Cancel',
  },
  resetToOriginal: {
    id: 'dentalPhotoToolbar.resetToOriginal',
    defaultMessage: 'Reset to original',
  },
  rotateLeft: {
    id: 'dentalPhotoToolbar.rotateLeft',
    defaultMessage: 'Rotate left',
  },
  rotateRight: {
    id: 'dentalPhotoToolbar.rotateRight',
    defaultMessage: 'Rotate right',
  },
  zoomIn: {
    id: 'dentalPhotoToolbar.zoomIn',
    defaultMessage: 'Zoom in',
  },
  zoomOut: {
    id: 'dentalPhotoToolbar.zoomOut',
    defaultMessage: 'Zoom out',
  },
  download: {
    id: 'global.download',
    defaultMessage: 'Download',
  },
  delete: {
    id: 'global.delete',
    defaultMessage: 'Delete',
  },
});
